import { useState, useEffect } from 'react';
import { MultiWebClientMerchantModel, MultiWebClientSubItemModel } from '@/User/domain';
import { useUserData } from '@/User/ui/context';

/**
 * Hook para manejar la selección del merchant y sincronización con localStorage
 */
export function useMasterSelectedMerchant(
  userMultiWeb: MultiWebClientMerchantModel[],
  setActiveMultiWebMerchant: (activeMerchantId: number) => Promise<boolean>
) {
  const { merchant } = useUserData();
  const [selected, setSelected] = useState<MultiWebClientMerchantModel | MultiWebClientSubItemModel>(
    userMultiWeb[0]
  );

  // Restaurar selección desde localStorage al montar
  useEffect(() => {
    // const stored = localStorage.getItem('current');
    // if (stored) {
    //   const parsed = JSON.parse(stored);
    //   setSelected(parsed);
    // } else {
    //   setSelected(userMultiWeb[0]);
    // }
    setSelected({ 
      cif: merchant.document,
      code: merchant.id,
      name: merchant.name,
      isIndependent: merchant.isIndependent,
      isParent: merchant.isParent,
      isParentWithHardDependency: merchant.isParentCommercial,
      isParentCommercial: merchant.isParentCommercial,
      isMasterGroup: merchant.isMasterGroup,
    })
  }, [userMultiWeb]);

  // Maneja la selección y notifica al padre
  const handleSetSelected = async (item: MultiWebClientMerchantModel | MultiWebClientSubItemModel) => {
    // localStorage.setItem('current', JSON.stringify(item));
    await setActiveMultiWebMerchant(item.code);
    setSelected(item);
  };

  return { selected, handleSetSelected };
}
